import React, { useState, useContext } from "react";
import { useCycle } from "framer-motion";
import { BsSearch } from "react-icons/bs";

const SiteContext = React.createContext();

const SiteProvider = ({ children }) => {
  const links = [
    { name: "Home ↗", to: "/", id: 1, icon: "" },
    { name: "Services ↗", to: "/services", id: 2, icon: "" },
    { name: "Work ↗", to: "/work", id: 3, icon: "" },
    { name: "Insights ↗", to: "/insights", id: 4, icon: "" },

    { name: "About us ↗", to: "/about-us", id: 5, icon: "" },
    { name: "Contact us ↗", to: "/contact-us", id: 6, icon: "" },
    {
      name: "Search",
      to: "/search",
      id: 7,
      icon: (
        <BsSearch className="inline-block ml-2 text-xl text-novaBlue -mt-1" />
      ),
    },
  ];

  const [showNavbar, setShowNavbar] = useState(false);
  const [showWebinar, setShowWebinar] = useState(false);
  const [open, cycleOpen] = useCycle(false, true);


  const mobileVariants = {
    closed: {
      transition: {
        staggerChildren: 0.25,
        staggerDirection: -1,
      },
    },
    open: {
      transition: {
        staggerChildren: 0.25,
        staggerDirection: 1,
        delayChildren: 0.5,
      },
    },
  };

  const itemVariants = {
    closed: {
      opacity: 0,
    },
    open: { opacity: 1 },
  };
  

  return (
    <SiteContext.Provider
      value={{
        showNavbar,
        setShowNavbar,
        showWebinar,
        setShowWebinar,
        links,
        mobileVariants,
        itemVariants,
        open,
        cycleOpen,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(SiteContext);
};

export { SiteContext, SiteProvider };
